import React from 'react'

import Hero from '../components/ProgramOverview/Hero'
import Row from '../components/Shared/Row'
import Column from '../components/Shared/Column'

class NominateAStudent extends React.Component {
    render() {

        return (
            <div>
                <Hero
                    title="Nominate A Student"
                />
                <Row className="page-intro">
                    <Column width="8" offsetL="2" tablet="12">
                        <h2 className="h2" style={{ marginBottom: '20px' }}>WE INVITE EDUCATORS TO NOMINATE STUDENTS FOR GLOBAL CITIZEN YEAR.</h2>
                        <div dangerouslySetInnerHTML={{ __html:
                            `<p style="margin-bottom: 15px;">Global Citizen Year is a nonprofit pioneering a model that wraps curriculum and coaching around real-world experience to transform the trajectory of our most promising young leaders. Working with colleges, companies and community partners, Global Citizen Year is forging a new educational pathway to launch the leaders our world needs now.</p>
                            <p>We run 2 programs:</p>
                            <ul>
                                <li><em>The Academy:</em> a semester-long virtual leadership program for students aged 17-21</li>
                                <li><em>The Fellowship:</em> a school-year long deep immersion fellowship abroad.</li>
                            </ul>
                            <p style="margin-bottom: 15px;">We’d love your help finding students who are the right fit for our programs. The nomination is completely non-binding. We’ll reach out to any student you nominate to let them know they’ve been nominated, share more information, help them figure out which program is right for them and guide them through the application process.</p>
                            <p style="margin-bottom: 15px;">Take 5 min to fill out this form and we’ll follow up with the student from there!</p>` }} />
                    </Column>
                </Row>
                <iframe src="/nominate-form.html" frameBorder="0" width="100%" height="650px" style={{ border: '0px' }}></iframe>
            </div>
        )
    }
}

export default NominateAStudent



// WEBPACK FOOTER //
// ./src/pages/nominate-a-student.js